import { useLDFlags } from '@/app/core/hooks/useLDFlags'
import {
  getUserVCPermissions,
  isCheatSheet,
} from '@/app/crunches/[id]/InfoPanel/utils'
import { User } from '@/dc-shared-web/src'
import { VCCardProps } from '@/dc-shared-web/src/hooks/api/comparison'
import {
  CrunchData,
  DocumentSvcCrunches,
} from '@/dc-shared-web/src/hooks/api/document/types'
import { useMemo } from 'react'

type UseCanUploadVersionProps = (args: {
  crunchDataSvcCrunches: DocumentSvcCrunches | undefined
  user: User
  crunchData: CrunchData | undefined
  comparisonList: VCCardProps[] | undefined
}) => boolean

export const useCanUploadVersion: UseCanUploadVersionProps = ({
  crunchDataSvcCrunches,
  user,
  crunchData,
  comparisonList,
}) => {
  const {
    flags: { versionCompareDiscoverabilityImprovements },
  } = useLDFlags()

  const hasVersionComparison = Boolean(
    comparisonList && comparisonList.length > 0
  )

  const userVCPermissions = getUserVCPermissions({
    user,
    hasVersionComparison,
    teamId: crunchData?.teamId || undefined,
  })

  const hasNoSecondVersion =
    !crunchDataSvcCrunches?.versions ||
    crunchDataSvcCrunches.versions.length <= 1

  const hasPlaybookApplied =
    crunchData?.appliedPlaybooks && crunchData.appliedPlaybooks.length > 0

  const canUploadVersion = useMemo(() => {
    return (
      /* Feature flag must be enabled */
      versionCompareDiscoverabilityImprovements &&
      /* The current document must NOT be a cheatsheet */
      !isCheatSheet(crunchData) &&
      /* The current document must NOT have playbooks applied */
      !hasPlaybookApplied &&
      /* There must NOT be a second version of this document */
      hasNoSecondVersion &&
      /* The user must have permissions for version comparison */
      userVCPermissions
    )
  }, [
    versionCompareDiscoverabilityImprovements,
    crunchData,
    hasPlaybookApplied,
    hasNoSecondVersion,
    userVCPermissions,
  ])

  return canUploadVersion
}
